import React from 'react';
import { Button, Form, Icon } from 'semantic-ui-react';
import {
  OPENLUX_DEFAULTS_V1014,
  openLuxRulesV1014,
  buildOpenLuxSubmissionV1015,
} from './openluxConfigV1014';
import './OpenLuxProfileV1014.css';

export default function OpenLuxProfileV1014({
  config,
  onChange,
  t,
  draft,
  onDraftChange,
  disabled = false,
}) {
  const label = (key) => t(`channel.edit.openlux_v1014.${key}`);
  const rules = openLuxRulesV1014(config);
  const custom = config.openlux_model_strategies_v1014 || {};
  const options = ['gemini_image', 'passthrough'].map((value) => ({
    key: value,
    value,
    text: label(value),
  }));
  const update = (value) =>
    onChange(null, { name: 'openlux_model_strategies_v1014', value });
  const add = () => {
    try {
      if (!draft.model.trim())
        throw new Error('channel.edit.openlux_v1014.invalid');
      const next = buildOpenLuxSubmissionV1015(config, draft);
      update(next.openlux_model_strategies_v1014);
      onDraftChange({ ...draft, model: '', error: '' });
    } catch (error) {
      onDraftChange({ ...draft, error: error.message });
    }
  };
  return (
    <section
      className='openlux-profile-v1014'
      data-testid='openlux-profile-v1014'
      aria-label={label('rules')}
    >
      <h3>{label('rules')}</h3>
      {Object.entries(rules).map(([model, selected]) => (
        <div className='openlux-rule-v1014' key={model} data-model={model}>
          <div className='openlux-model-v1014'>
            <code>{model}</code>
            <small>
              {label(Object.hasOwn(custom, model) ? 'custom' : 'builtin')}
            </small>
          </div>
          <Form.Dropdown
            disabled={disabled}
            selection
            aria-label={`${model} ${label('strategy')}`}
            options={options}
            value={selected}
            onChange={(_, { value }) => update({ ...custom, [model]: value })}
          />
          <Button
            type='button'
            icon
            disabled={disabled || !Object.hasOwn(custom, model)}
            aria-label={`${label(
              Object.hasOwn(OPENLUX_DEFAULTS_V1014, model) ? 'reset' : 'remove'
            )} ${model}`}
            title={label(
              Object.hasOwn(OPENLUX_DEFAULTS_V1014, model) ? 'reset' : 'remove'
            )}
            onClick={() => {
              const next = { ...custom };
              delete next[model];
              update(next);
            }}
          >
            <Icon
              name={
                Object.hasOwn(OPENLUX_DEFAULTS_V1014, model)
                  ? 'undo'
                  : 'trash alternate outline'
              }
            />
          </Button>
        </div>
      ))}
      <div className='openlux-rule-v1014 openlux-add-v1014'>
        <Form.Input
          disabled={disabled}
          aria-label={label('model')}
          placeholder={label('model')}
          value={draft.model}
          error={draft.error ? t(draft.error) : false}
          onChange={(_, { value }) =>
            onDraftChange({ ...draft, model: value, error: '' })
          }
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              add();
            }
          }}
        />
        <Form.Dropdown
          disabled={disabled}
          selection
          aria-label={label('new_strategy')}
          options={options}
          value={draft.strategy}
          onChange={(_, { value }) =>
            onDraftChange({ ...draft, strategy: value, error: '' })
          }
        />
        <Button
          disabled={disabled}
          type='button'
          icon
          title={label('add')}
          aria-label={label('add')}
          onClick={add}
        >
          <Icon name='plus' />
        </Button>
      </div>
    </section>
  );
}
